import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { selectAuth } from '../store/slices/authSlice';

const ProtectedRoute = ({ children, allowedRoles = ['admin', 'partner'] }) => {
  // Get authentication state from Redux store using hooks
  const { isAuthenticated, user } = useAppSelector(selectAuth);
  const userRole = user?.role;
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
